<template>
    <div id="header-wrap">
        <div class="header-wrap">
            <!-- logo -->
            <div class="logo">
                <img v-if="!isTianJin" src="../../assets/imgs/logo1.png" alt="logo"/>
                <div class="text" v-else>
                    <span>天津奇立软件技术有限公司</span>
                    <!-- <span>北京奇立软件技术有限公司</span> -->
                </div>
            </div>
            <!-- 右侧导航 -->
            <ul class="Navigation">
                <router-link to="/home">
                    <li :class="{ active: $route.path.indexOf('/home') !== -1 }">首页</li>
                </router-link>
                <router-link to="/product">
                    <li
                            :class="{ active: $route.path.indexOf('/product') !== -1 }"
                            @mouseenter="showNav"
                    >
                        产品技术
                    </li>
                </router-link>

                <router-link to="/solution">
                    <li :class="{ active: $route.path.indexOf('/solution') !== -1 }">
                        解决方案
                    </li>
                </router-link>

                <router-link to="/openPlatform">
                    <li :class="{ active: $route.path.indexOf('/openPlatform') !== -1 }">
                        开放平台
                    </li>
                </router-link>

                <!-- 暂时注释掉，待定！！！！！勿删！！！ -->
                <!-- <li @click="aaa">客户案例</li>
                <li @click="aaa">关于奇立</li>
                <li @click="aaa">关于我们</li>-->
            </ul>
        </div>
        <!-- hover产品中心 显示的弹框 -->
        <ul class="nav" v-show="isShowNav" @mouseleave="closeNave">
            <li @click="$router.push('/product/superiorProducts')">
                <div class="icon znhs-icon"></div>
                <div class="content">
                    <div>二手良品</div>
                    <div>精选优质二手机</div>
                </div>
            </li>
            <li @click="$router.push('/product/easyChange')">
                <div class="icon qsh-icon"></div>
                <div class="content">
                    <div>轻松换</div>
                    <div>以旧换新超值平台</div>
                </div>
            </li>
            <li @click="$router.push('/product/safetyRecovery')">
                <div class="icon znhs-icon"></div>
                <div class="content">
                    <div>安全回收</div>
                    <div>拥有隐私粉碎技术支持</div>
                </div>
            </li>
            <li @click="$router.push('/product/intelligentRecovery')">
                <div class="icon znhs-icon"></div>
                <div class="content">
                    <div>智能回收机</div>
                    <div>自助回收/以旧换新，方便快捷</div>
                </div>
            </li>
            <li @click="$router.push('/product/tianJiHui')">
                <div class="icon tjh-icon"></div>
                <div class="content">
                    <div>天机汇</div>
                    <div>专业B2B二手电子产品买卖平台</div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                // 是否显示导航菜单
                isShowNav: false,
            };
        },
        methods: {
            goto(path) {
                if (this.$router.path !== path) {
                    this.$router.push(path);
                }
            },
            // 展示产品技术的弹框
            showNav() {
                if (this.$route.path.indexOf("/product") !== -1) {
                    this.$bus.$emit("showNav");
                }
                this.isShowNav = true;
            },
            closeNave() {
                this.isShowNav = false;
            },
            aaa() {
                alert("暂未开放");
            },
        },
        computed: {
            isTianJin() {
                var host = window.location.host;

                if (
                    host.indexOf("m.360tcb.com") !== -1 ||
                    host.indexOf("360tcb.com") !== -1
                ) {
                    return true;
                } else {
                    return false;
                }
            },
        },

        mounted() {
            this.$bus.$on("closeNave", this.closeNave);
        },
    };
</script>

<style lang="scss" scoped>
    #header-wrap {
        background-color: #fff;
        height: 80px;
        border-bottom: 1px solid #dadada;
        position: relative;
        z-index: 10;

        .header-wrap {
            width: 1200px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .logo {
                // width: 131px;
                // height: 33px;
                display: flex;

                img {
                    width: 131px;
                    height: 33px;
                }

                .text {
                    margin-left: 15px;
                    font-size: 22px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    // font-weight: bolder;
                    letter-spacing: 2px;
                }
            }

            .Navigation {
                display: flex;
                font-size: 15px;

                li {
                    height: 80px;
                    line-height: 80px;
                    text-align: center;
                    position: relative;
                    padding: 0 21px;
                    box-sizing: border-box;
                    color: #333;
                }

                li::after {
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: 100%;
                    width: 0;
                    height: 100%;
                    border-bottom: 4px solid #26c9a5;
                    transition: 0.3s all linear;
                }

                li:hover::after {
                    width: 100%;
                    left: 0;
                }

                li:hover ~ li:after {
                    left: 0;
                }

                .active {
                    border-bottom: 4px solid #26c9a5;
                    transition: 0.2s all linear;
                    color: #26c9a5;
                }
            }
        }

        // nav
        .nav {
            width: 1032px;
            height: 387px;
            background-color: #f9faff;
            margin: 0 auto;
            padding: 47px 30px 12px 60px;
            box-sizing: border-box;
            display: flex;
            flex-wrap: wrap;
            // position: relative;
            position: absolute;
            left: 16%;
            z-index: 2;

            li {
                width: 207px;
                height: 134px;
                background-color: #fff;
                position: relative;
                margin-right: 28px;
                margin-bottom: 30px;

                .icon {
                    width: 31px;
                    height: 31px;
                    background-image: url("../../assets/imgs/product/jdicon.png");
                    background-repeat: no-repeat;
                    background-size: 100%;
                    position: absolute;
                    left: 34px;
                    top: 32px;
                }

                .lp-icon {
                    background-image: url("../../assets/imgs/product/360icon.png");
                }

                .qsh-icon {
                    background-image: url("../../assets/imgs/product/qshicon.png");
                }

                .aqhs-icon {
                    background-image: url("../../assets/imgs/product/360icon.png");
                }

                .znhs-icon {
                    background-image: url("../../assets/imgs/product/znhs.png");
                }

                .tjh-icon {
                    background-image: url("../../assets/imgs/product/jdicon.png");
                }

                .content {
                    width: 102px;
                    transform: translate(80px, 35px);

                    div:nth-child(1) {
                        margin-bottom: 18px;
                        font-size: 16px;
                        color: #000;
                        font-weight: 600;
                    }

                    div:nth-child(2) {
                        color: #999999;
                        font-size: 14px;
                        font-weight: 600;
                        line-height: 21px;
                    }
                }
            }
        }
    }
</style>
